import { Component, EventEmitter, Input, Output } from '@angular/core';
import { VentanaUtils } from '../../utils/ventana.utils';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-alerta-consultenos',
  templateUrl: './alerta-consultenos.component.html',
  styleUrls: ['./alerta-consultenos.component.scss']
})
export class AlertaConsultenosComponent {
  public static nueva_consulta: string = "NUEVA_CONSULTA";
  public static cerrar_asistente: string = "CERRAR_ASISTENTE";

  constructor(public window: VentanaUtils,
    public dialogRef: MatDialogRef<AlertaConsultenosComponent>
  ) {
    AlertaConsultenosComponent.nueva_consulta = "NUEVA_CONSULTA";
    AlertaConsultenosComponent.cerrar_asistente = "CERRAR_ASISTENTE";
  }

  cerrar() {
    this.dialogRef.close(AlertaConsultenosComponent.cerrar_asistente);
  }

  nuevaConsulta() {
    this.dialogRef.close(AlertaConsultenosComponent.nueva_consulta);
  }


}
